// src/components/ui/SectionTitle.js
import React from 'react';
import styled from 'styled-components';
import { fadeIn } from '../../styles/animations';

const TitleWrapper = styled.div`
  position: relative;
  margin-bottom: ${props => props.theme.spacing.lg};
  text-align: ${props => props.centered ? 'center' : 'left'};
  animation: ${fadeIn} 0.8s ease-out forwards;
`;

const Title = styled.h2`
  color: ${props => props.theme.colors.primary};
  font-size: ${props => props.theme.fontSizes.xxl};
  margin-bottom: ${props => props.theme.spacing.sm};
  position: relative;
  display: ${props => props.centered ? 'inline-block' : 'block'};
  
  &:after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: ${props => props.centered ? '50%' : '0'};
    transform: ${props => props.centered ? 'translateX(-50%)' : 'none'};
    width: 60px;
    height: 3px;
    background-color: ${props => props.theme.colors.primary};
  }
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: ${props => props.theme.fontSizes.xl};
  }
`;

const Subtitle = styled.p`
  color: ${props => props.theme.colors.textLight};
  font-size: ${props => props.theme.fontSizes.large};
  margin-top: ${props => props.theme.spacing.sm};
  max-width: ${props => props.centered ? '800px' : '600px'};
  margin-left: ${props => props.centered ? 'auto' : '0'};
  margin-right: ${props => props.centered ? 'auto' : '0'};
`;

const SectionTitle = ({ text, subtitle, centered }) => {
    return (
        <TitleWrapper centered={centered}>
            <Title centered={centered}>{text}</Title>
            {subtitle && <Subtitle centered={centered}>{subtitle}</Subtitle>}
        </TitleWrapper>
    );
};

export default SectionTitle;